<template>
    <div class="widget-time-relative w-full">
        <VcSelect
            :model-value="timeModel.Date_interval"
            :options="translatedOptions"
            :config="{ valueKey: 'Date_interval', labelKey: 'translatedLabel' }"
            :multiple="false"
            placeholder="Select"
            class="w-full"
            @update:model-value="onChange"
        />
    </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import { VcSelect } from '@voicenter-team/voicenter-ui-plus'
import { WidgetTime } from '@/types/dashboard'
import { useVModel } from '@vueuse/core'
import { useI18n } from 'vue-i18n'

const { t } = useI18n()

const props = defineProps<{
    modelValue: WidgetTime
    widgetTimeOptions?: Array<Record<string, string>>
}>()
const emit = defineEmits<{
    (e: 'update:modelValue', v: WidgetTime): void
}>()

const timeModel = useVModel(props, 'modelValue', emit)

const translatedOptions = computed(() => {
    return (props.widgetTimeOptions || []).map(item => ({
        ...item,
        translatedLabel: t(item.label)
    }))
})

function onChange (dateInterval: string) {
    const widgetTimeOption = props.widgetTimeOptions?.find(el => Number(el.Date_interval) === Number(dateInterval))
    if (widgetTimeOption) {
        timeModel.value.Date_interval = widgetTimeOption.Date_interval
        timeModel.value.datedeff = widgetTimeOption.datedeff
        timeModel.value.label = widgetTimeOption.label
    }
}

function initData () {
    const options = props.widgetTimeOptions || []
    const dateInterval = timeModel.value.Date_interval
    const isExistDateIntervalInRange = props.widgetTimeOptions?.find(el => el.Date_interval === dateInterval)
    const defaultDateInterval = isExistDateIntervalInRange ? isExistDateIntervalInRange.Date_interval : options[0]?.Date_interval
    const defaultDateDeff = isExistDateIntervalInRange ? isExistDateIntervalInRange.datedeff : options[0]?.datedeff
    const defaultDateLabel = isExistDateIntervalInRange ? isExistDateIntervalInRange.label : options[0]?.label

    timeModel.value.Date_interval = defaultDateInterval
    timeModel.value.datedeff = defaultDateDeff
    timeModel.value.label = defaultDateLabel
}

initData()
</script>
